import seoMeta from "@/common/assets/json/seoMeta.json";

interface RouteMeta {
  title?: string;
  description?: string;
}

const META = seoMeta as unknown as {
  baseUrl: string;
  defaultTitle: string;
  defaultDescription: string;
  ogImage?: string;
  routes: Record<string, RouteMeta>;
};

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * 현재 라우트 경로에 맞춰 title / description / canonical / og 태그를 갱신한다.
 * SPA는 라우트가 바뀌어도 초기 HTML의 메타가 그대로 남으므로(특히 canonical이
 * 홈으로 고정되면 모든 페이지가 홈의 중복으로 취급됨) 라우트마다 이 함수를 호출한다.
 */
export function applySeo(path: string) {
  const routeMeta = META.routes[path] || {};
  const title = routeMeta.title || META.defaultTitle;
  const description = routeMeta.description || META.defaultDescription;
  const url = META.baseUrl + (path === "/" ? "" : path);

  document.title = title;
  upsertMeta("name", "description", description);
  upsertCanonical(url);
  upsertMeta("property", "og:title", routeMeta.title || title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:url", url);
}
